import React, {Component} from 'react';
import Header from "./components/Header";
import Footer from "./components/Footer";
import {Route, Routes} from "react-router-dom";
import Live from "./pages/Live";
import Home from "./pages/Home";

class App extends Component {
    render() {
        return (
            <div className="min-h-screen flex flex-col">
                <Header/>
                <main className="flex-1 w-full">
                    <Routes>
                        <Route path='/live' element={<Live/>}/>
                        <Route path='/' element={<Home/>}/>
                    </Routes>
                </main>
                <Footer/>
            </div>
        );
    }
}

export default App;